import * as angular from 'angular';

class CampaignOverview {
    campaign: any;
    waiting: boolean;
    showCompetition: boolean;
    showAdventCalendarParams: boolean;
}

angular
    .module('app.retailes.common')
    .component('campaignOverview', {
        template: require('./campaign-overview.html'),
        controller: CampaignOverview,
        controllerAs: 'vm',
        bindings: {
            campaign: '<',
            waiting: '<',
            showCompetition: '<',
            showAdventCalendarParams: '<'
        }
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/components/campaign-overview/campaign-overview.component.ts